import {
  Form,
  Checkbox,
  Link,
  Button,
  Space,
  Message,
  Input,
} from '@arco-design/web-react';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import eye_open from '@/assets/login/eye_open.png';
import CryptoJS from 'crypto-js';
import eye_close from '@/assets/login/eye_close.png';
import './style/style.less';
const FormItem = Form.Item;
import { observer } from 'mobx-react-lite';
import Cookies from 'js-cookie';
import { SecureStringGenerator } from '@/utils';
import { appStore, userStore } from '@/mobx';
import Login from '@/mobx/modules/login';

const Accountlogin = (props: any) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const formref = useRef(form);
  const [radioopp, setradioopp] = useState(0);
  const [loading, setLoading] = useState(false);
  const [checkdata, setcheckdata] = useState(false);
  console.log('accountLogin', props);

  const { login } = props;
  const location = useLocation();
  const [urlstate, setstate] = useState(null);
  const [passVisibility, setPassVisibility] = useState<boolean>(false);

  useEffect(() => {
    try {
      const code = location.search.split('=')[1];
      setstate(code);
    } catch (e) {}
  }, [location]);

  function validatePassword(value, callback) {
    if (!value) {
      callback(<div>密码不能为空</div>);
    } else if (!/^.{6,}$/.test(value)) {
      callback(
        <div>请输入6-12个字符，支持数字、大小写字母和符号至少包含一种</div>
      );
    } else {
      callback();
    }
  }
  useEffect(() => {
    if (Cookies.get('Logindata')) {
      const encryptedData = Cookies.get('Logindata');

      try {
        // 解密数据
        const bytes = CryptoJS.AES.decrypt(
          encryptedData,
          SecureStringGenerator.generate(16)
        );

        // 将解密后的字节转换为 UTF-8 字符串
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        // 检查解密后的数据是否是有效的 UTF-8 字符串
        if (decrypted) {
          try {
            // 解析解密后的 JSON 字符串
            const data = JSON.parse(decrypted);
            const { phone_number, password } = data;

            // 设置表单字段值
            formref?.current.setFieldValue('phone_number', phone_number);
            formref?.current.setFieldValue('password', password);

            // 设置 checkdata 为 true
            setcheckdata(true);
          } catch (error) {
            console.error('解析解密后的数据时出错:', error);
          }
        } else {
          console.error('解密后的数据不是有效的 UTF-8 字符串。');
        }
      } catch (error) {
        console.error('解密数据时出错:', error);
      }
    }

    // formref?.current.setFieldValue('phone_number', '15755315528');
    // formref?.current.setFieldValue('password', '123456');
  }, []);

  async function onSubmitClick(datalist) {
    console.log(datalist);
    try {
      setLoading(true);
      await Login.Accc_use_login(datalist);
      await userStore.getUserInfo();
      history.replace('/matrix');
    } catch (error) {
      setLoading(false);
      console.log('error', error);
      return Promise.reject(error);
    }
  }

  const actvieclike = () => {
    props.activepassword();
  };

  const handleOpenApp = async () => {
    const installed = await checkAndOpenApp({
      protocol: 'geo-zx',
      downloadUrl: 'https://your-app.com/download',
      onSuccess: () => {
        console.log('应用启动成功，可以埋点');
        // 可以记录到统计
      },
      onFail: () => {
        alert('未安装');
      },
    });

    console.log('检测结果:', installed);
  };

  const validatePhoneNumber = (value, callback) => {
    const regex = /^1(3|4|5|6|7|8|9)\d{9}$/;
    if (!value) {
      callback(<div>请输入正确的用户名</div>);
    } else {
      callback();
    }
  };

  const handleSubmit = async () => {
    await formref.current.validate();
    const password = formref.current.getFieldValue('password');
    const phone_number = formref.current.getFieldValue('phone_number');
    console.log(phone_number, password);

    onSubmitClick({ phone_number, password });
  };

  return (
    <div>
      <Form
        ref={formref}
        autoComplete="off"
        className="form-cottop"
        onKeyUp={(e) => {
          console.log(e.key);
          if (e.key === 'Enter') {
            handleSubmit();
          }
        }}
      >
        <FormItem
          field="phone_number"
          rules={[
            { validator: validatePhoneNumber, validateTrigger: 'onBlur' },
          ]}
        >
          <Input
            style={{ fontSize: '16px' }}
            className="form-contorinput"
            autoComplete="username"
            allowClear={true}
            placeholder="请输入账号"
          />
        </FormItem>
        <FormItem
          field="password"
          rules={[{ validator: validatePassword, validateTrigger: ['onBlur'] }]}
        >
          <Input.Password
            defaultValue="password"
            autoComplete="current-password"
            placeholder="请输入密码"
            visibility={passVisibility}
            onVisibilityChange={setPassVisibility}
            suffix={
              <img
                src={passVisibility ? eye_open : eye_close}
                style={{ cursor: 'pointer' }}
                width={12}
              />
            }
          />
        </FormItem>
        <Space direction="vertical">
          <Button
            type="primary"
            long
            loading={loading}
            onClick={async () => {
              if (formref.current) {
                try {
                  // await formref.current.validate();
                  // const password = formref.current.getFieldValue('password');
                  // const phone_number =
                  //   formref.current.getFieldValue('phone_number');
                  // console.log(phone_number, password);
                  // onSubmitClick({ phone_number, password });
                  handleSubmit();
                } catch (_) {
                  // console.error(_);
                }
              }
            }}
            className="styleInputbutton"
          >
            登录
          </Button>
          {/* <a href="geo-zx://open">打开摘星小助手</a> */}
          {/* <a href="geo-ys://open">打开云视小助手</a> */}

          {/* {!appStore.isOdm ? (
            <div className="radiobody" style={{ cursor: 'pointer' }}>
              {radioopp === 0 ? (
                <div
                  className="logi_form_titlerekeli"
                  onClick={() => {
                    setradioopp(1);
                  }}
                >
                  <p className="ardioactiveer"></p>
                  <span>我已阅读并同意</span>
                </div>
              ) : (
                <div
                  className="logi_form_titlerekeli"
                  onClick={() => {
                    setradioopp(0);
                  }}
                >
                  <img src={logoradiob} alt="" className="ardioactive" />
                  <span>我已阅读并同意</span>
                </div>
              )}

              <span className="login-form-itemhover">
                <span
                  style={{
                    color: '#165dff',
                  }}
                  onClick={() => {
                    // window.open("/policy.html", "policy");
                  }}
                >
                  平台隐私政策
                </span>
                &nbsp; 与&nbsp;
                <span
                  style={{
                    color: '#165dff',
                  }}
                  onClick={() => {
                    // window.open("/agreement.html", "agreement");
                  }}
                >
                  平台用户服务协议
                </span>
              </span>
            </div>
          ) : null} */}
          {/* <div>
            <p>17627921976</p>
            <p>@QQQwww123</p>
          </div> */}
        </Space>
      </Form>
    </div>
  );
};
export default observer(Accountlogin);
